// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1e4ai","options":"AnswerScale_options__3VIHu","selected":"AnswerScale_selected__-v3yc"};